import { render } from "./become-an-affiliate.vue?vue&type=template&id=d9b7f682"
import script from "./become-an-affiliate.vue?vue&type=script&lang=js"
export * from "./become-an-affiliate.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__